module.exports = __webpack_public_path__ + "assets/img/download-tips2.efe7d4fb.png";